import RequestRoute from './_config/portail.request.routes';
import requestList from './components/request-list';
import addUserRequestList from './components/add-user-request-list';
import navRequest from './components/nav-request';
import acceptationUserPortailModal from './components/acceptation-user-portail-modal';

const moduleName = 'app.massia.common.portail.request';

angular
	.module(moduleName, [])
	.config(RequestRoute)
	.component('portailNavRequest', navRequest)
	.component('portailRequestList', requestList)
	.component('acceptationUserPortailModal', acceptationUserPortailModal)
	.component('portailAddUserRequestList', addUserRequestList);
// angular.module(moduleName, []).config(RequestRoute).component('addUserRequestList', addUserRequestList);

export default moduleName;
